import React, { FC } from 'react';
import { useFederalDistrictsFetchQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface FederalDistricts extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const FederalDistricts: FC<FederalDistricts> = ({ label, error, control, name, rules }) => {
  const { data } = useFederalDistrictsFetchQuery();
  return (
    <Select
      label={label}
      data={(data && data.dirFederalDistricts) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default FederalDistricts;
